import React from 'react';
import './FaqItem.css';
import Downarrow from '../../../../../assets/DownArrow.svg';

const FaqItem = ({ index, question, answer, isOpen, onToggle }) => {
  const handleClick = () => {
    onToggle(index);
  };

  // Check if the answer contains HTML tags
  const containsHtml = /<\/?[a-z][\s\S]*>/i.test(answer);

  return (
    <div className="faq-item">
      <div className="faq-question" onClick={handleClick}>
        <div className={`faq-icon ${isOpen ? 'open' : ''}`}>
          <img className='downarrow' src={Downarrow} alt="Toggle Icon" />
        </div>
        <div className='question'>
          {question}
        </div>
      </div>
      {isOpen && (
        <div className="faq-answer">
          {containsHtml ? (
            <div dangerouslySetInnerHTML={{ __html: answer }} />
          ) : (
            <p>{answer}</p>
          )}
        </div>
      )}
    </div> 
  );
};

export default FaqItem;
